import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { NGXLogger } from 'ngx-logger';
import { Rendicontazione } from '../../../models/rendicontazione.model';

@Component({
  selector: 'app-conferma-eliminazione-file',
  templateUrl: './conferma-eliminazione-file.component.html',
  styleUrls: ['./conferma-eliminazione-file.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    RippleModule,
    ToastModule,
    DividerModule
  ],
  providers: [MessageService]
})
export class ConfermaEliminazioneFileComponent {
  @Input() visible: boolean = false;
  @Input() intervento: any;
  @Input() rendicontazione: Rendicontazione | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() eliminazioneConfermata = new EventEmitter<void>();

  eliminazioneInCorso: boolean = false;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger
  ) {}

  onHide() {
    // Blocca la chiusura se l'eliminazione è in corso
    if (this.eliminazioneInCorso) {
      return;
    }

    this.visibleChange.emit(false);
  }

  annulla() {
    this.visibleChange.emit(false);
  }

  confermaEliminazione() {
    if (!this.intervento) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Impossibile eliminare i file: intervento non disponibile',
        life: 3000
      });
      return;
    }

    this.eliminazioneInCorso = true;

    // Emetti evento di eliminazione confermata
    this.logger.info(`[CONFERMA-ELIMINAZIONE-FILE] Eliminazione confermata per l'intervento ID: ${this.intervento.id}`);

    // Simuliamo un breve ritardo per l'elaborazione
    setTimeout(() => {
      this.eliminazioneConfermata.emit();
      this.eliminazioneInCorso = false;
      this.visibleChange.emit(false);
    }, 500);
  }
}
